import type { RouteObject } from 'react-router';
import { RequerPermissao } from '@/app/RequerPermissao';
import { paginaSobDemanda } from '@/app/pagina-sob-demanda';

/**
 * Rotas de Leads, cada grupo sob `RequerPermissao` como **rota-mãe**.
 *
 * 🚨 Segunda tranca. A que vale é o `@Permissao()` de cada rota do backend: aqui só evitamos mostrar uma tela
 * que o servidor negaria.
 *
 * Iteração 10.2: as listas (`leads.listas`) e os tipos de atividade (`atividades.tipos`). Iteração 10.4: as
 * telas do lead, sob `leads.ver`, com aninhamento para o resto — cadastro em `leads.criar` + `pessoas.ver` (a
 * pessoa se procura em Pessoas), edição em `leads.editar`.
 *
 * As estáticas (`/leads/listas`, `/leads/novo`) vêm **antes** de `/leads/:id`. O roteador ranqueia por
 * especificidade de qualquer forma; a ordem é para quem lê. Cada página carrega sob demanda.
 */
export const rotas: RouteObject[] = [
  {
    element: <RequerPermissao permissao="leads.listas" />,
    children: [
      {
        path: '/leads/listas',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaListasDeLeads'),
          (m) => m.PaginaListasDeLeads,
          'Abrindo as listas…',
        ),
      },
    ],
  },
  {
    element: <RequerPermissao permissao="leads.ver" />,
    children: [
      {
        path: '/leads',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaLeads'),
          (m) => m.PaginaLeads,
          'Abrindo os leads…',
        ),
      },
      {
        element: <RequerPermissao permissao="leads.criar" />,
        children: [
          {
            element: <RequerPermissao permissao="pessoas.ver" />,
            children: [
              {
                path: '/leads/novo',
                element: paginaSobDemanda(
                  () => import('./paginas/PaginaLeadNovo'),
                  (m) => m.PaginaLeadNovo,
                  'Abrindo o cadastro…',
                ),
              },
            ],
          },
        ],
      },
      {
        element: <RequerPermissao permissao="leads.editar" />,
        children: [
          {
            path: '/leads/:id/editar',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaLeadEditar'),
              (m) => m.PaginaLeadEditar,
              'Abrindo a edição…',
            ),
          },
        ],
      },
      {
        element: <RequerPermissao permissao="leads.qualificar" />,
        children: [
          {
            path: '/leads/:id/qualificacao',
            element: paginaSobDemanda(
              () => import('./paginas/PaginaLeadQualificacao'),
              (m) => m.PaginaLeadQualificacao,
              'Abrindo o checklist…',
            ),
          },
        ],
      },
      {
        path: '/leads/:id',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaLeadDetalhe'),
          (m) => m.PaginaLeadDetalhe,
          'Abrindo o lead…',
        ),
      },
    ],
  },
  {
    element: <RequerPermissao permissao="atividades.tipos" />,
    children: [
      {
        path: '/tipos-atividade',
        element: paginaSobDemanda(
          () => import('./paginas/PaginaTiposAtividade'),
          (m) => m.PaginaTiposAtividade,
          'Abrindo os tipos de atividade…',
        ),
      },
    ],
  },
];
